import script from "./ProfileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileMenu.vue?vue&type=style&index=0&id=61c6fd84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c6fd84"]])

export default __exports__